module.exports = __webpack_public_path__ + "img/川射干.84aa50b7.jpg";